import React, { FC, useEffect } from 'react'
import _ from 'lodash'

// types
import { FolderReportProps, ReportFormParameters } from './reports'

type SortType = 'Rent Roll' | 'Tenant Name' | 'End Date' | 'Area'
export   const sortOptions = [
  { value: 'Rent Roll' },
  { value: 'Tenant Name' },
  { value: 'End Date' },
  { value: 'Area' }
]

type ReportType = 'folder_tenant_roster'
const displayName = 'Tenant Roster'

type TenantRosterParameters = ReportFormParameters & {
  report: ReportType
  sort: SortType
}

export const propertyFilter = (property) => property.type === 'Commercial'

export const TenantRoster: FC<FolderReportProps> = (props) => {
  useEffect(() => {
    props.setParameters(getParameters())
    props.setValid(true)
  }, [props.sort])

  function getParameters(): TenantRosterParameters {
    return {
      report: 'folder_tenant_roster',
      sort: props.sort as SortType || 'Rent Roll'
    }
  }

  return <></>
}

TenantRoster.displayName = displayName
